import React from 'react';
import { Input, Radio } from 'antd';

class IdentityInput extends React.Component {
  handleNumberChange = (e) => {
    this.triggerChange({ number: e.target.value });
  };

  handleTypeChange = (e) => {
    this.triggerChange({ type: e.target.value });
  };

  triggerChange = (changedValue) => {
    const { value, onChange } = this.props;
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  render() {
    const { value } = this.props;
    return (
      <span>
        <Radio.Group value={value.type} onChange={this.handleTypeChange}>
          <Radio value="VKN">Vergi No.</Radio>
          <Radio value="TCKN">TC No.</Radio>
        </Radio.Group>
        <Input
          maxLength="11"
          value={value.number}
          className="input__default"
          onChange={this.handleNumberChange}
        />
      </span>
    );
  }
}

export default IdentityInput;
